import { React } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Sidebar from './components/Sidebar';
import Home from './pages/Home';
import Resume from './pages/Resume';
import Publications from './components/Publications';
import PublicationDetail from './pages/PublicationDetail';
import NotFound from './pages/NotFound';
import './styles/loading.css';
import { loadSectionContent } from './utils/contentLoader';

function App() {
  const showSidebar = useLocation().pathname == '/' || useLocation().pathname == '/resume';

  const loadContent = async () => {
    try {
      await loadSectionContent('home');
      await loadSectionContent('resume');
    } catch (error) {
      console.log();
    } 
  };
  loadContent();

  return (
    <div className="app">
      <Header />
      <main className="main-content">
        {showSidebar && <Sidebar/>}
        <div className="container">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/resume" element={<Resume />} />
            <Route path="/publications" element={<Publications />} />
            <Route path="/publications/phd" element={<PublicationDetail isPhd={true} />} />
            <Route path="/publications/:year/:slug" element={<PublicationDetail />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default App;